import styled from '@emotion/styled';
import { IconName } from '@shared/components/core/images/IconMap';
import SrOnlyText from '@shared/components/core/text/SrOnlyText';
import { type ButtonType, ICoreButtonTypes } from '@shared/models/components/ICoreButtonProps';
import React, { forwardRef } from 'react';
import Button from './CoreButton';

export interface IIconsButtonProps {
    label: string;
    startIcon: IconName;
    circle?: boolean;
    hideBorder?: boolean;
    $color?: ICoreButtonTypes;
    disabled?: boolean;
    iconSize?: number;
    endIcon?: IconName;
    target?: string;
    href?: string;
    type?: ButtonType;
    onClick?: (
        event:
            | React.MouseEvent<HTMLButtonElement>
            | React.KeyboardEvent<HTMLButtonElement>
            | React.TouchEvent<HTMLButtonElement>
    ) => void;
}

const IconsButton = forwardRef<HTMLButtonElement, IIconsButtonProps>(
    ({ label, circle = false, $color = 'secondary', hideBorder = false, ...restProps }, ref) => {
        return (
            <StyledButton
                ref={ref}
                $color={$color}
                $size="quick"
                $borderRadius={circle}
                $hideBorder={hideBorder}
                {...restProps}>
                <SrOnlyText>{label}</SrOnlyText>
            </StyledButton>
        );
    }
);

const StyledButton = styled(Button, {
    shouldForwardProp: (prop) => prop !== '$borderRadius' && prop !== '$hideBorder',
})<{ $borderRadius: boolean; $hideBorder: boolean }>`
    height: min-content;
    gap: 0;
    padding: 0;
    max-width: min-content;
    ${(props) => (props.$hideBorder ? 'border: none;' : '')}
    ${(props) => (props.$borderRadius ? 'border-radius: 50%;' : '')}
    svg {
        padding: 0.5rem;
    }
`;

export default IconsButton;
